import { render } from "./ClientsToVisit.vue?vue&type=template&id=869ab2ca&scoped=true"
import script from "./ClientsToVisit.vue?vue&type=script&lang=js"
export * from "./ClientsToVisit.vue?vue&type=script&lang=js"

import "./ClientsToVisit.vue?vue&type=style&index=0&id=869ab2ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869ab2ca"]])

export default __exports__